// extracted by mini-css-extract-plugin
export default {"primary-button":"PrimaryButton_primary-button__pgLsz","disabled":"PrimaryButton_disabled__-VsEi"};